import { module } from 'modujs';
import { html } from '../utils/environment'


export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                toggler: 'toggleMenu'
            }
        }
    }

    init(){
        // this.isOpen = false
    }

    toggleMenu() {
        if(html.classList.contains('has-nav-open')) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        // this.isOpen = true

        this.call('open', null, 'Menu')
    }

    close() {
        // this.isOpen = false

        this.call('close', null, 'Menu')
    }
}
